import { render, staticRenderFns } from "./tpl.html?vue&type=template&id=6f31d7c4&scoped=true&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "../style/index.scss?vue&type=style&index=0&id=6f31d7c4&lang=scss&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&id=6f31d7c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f31d7c4",
  null
  
)

export default component.exports